// Module
var code = "<p>[# summary]</p> <h3 id=\"asset-symbol\">Asset {symbol}</h3> <p>{description}</p> <p>Issued by: {issuer}</p> <p>The Euro (sign: €; symbol: EUR) is the official currency of participating countries in the Europ zone.</p> ";
// Exports
export default code;